export { ExperienceType } from "@/generated/graphql";

export enum ExperienceAction {
  SEND_CHAT_MESSAGE = "send_chat_message",
  REPLY_TO_MESSAGE = "reply_to_message",
  LIKE_CHAT_MESSAGE = "like_chat_message",
  REPLY_TO_THREAD = "reply_to_thread",
  SELECT_OPTION = "select_option",
  QUIZ_ANSWER = "quiz_answer",
  RAFFLE_JOIN = "raffle_join",
  CREATE = "create",
  UPDATE = "update",
  LIVE_QUIZ = "live_quiz",
  LIVE_RAFFLE = "live_raffle",
  LIKE_THREAD = "like_thread",
  WIN_CONTEST = "win_contest",
  REQUEST_TO_JOIN_STAGE = "request_to_join_stage",
  DUPLICATE = "duplicate",
  ADD_AGENDA = "add_agenda",
  PREPARE_SHOW = "prepare_show",
  CLAIM_OFFER = "claim_offer",
  WATCH_REPLAY = "watch_replay",
}
